(() => {
 let observer;
 const init = () => {
  observer?.disconnect();
  const header = document.getElementById('navbar');
  if (!header) return;
  const resize = () => document.documentElement.style.setProperty('--mc-header-height', `${header.offsetHeight}px`);
  observer = new ResizeObserver(resize);observer.observe(header);resize();
  const close = header.querySelector('[data-mc-announcement-close]');
  if (close && !close.dataset.ready) {close.dataset.ready = 'true';close.addEventListener('click', () => {header.querySelector('[data-mc-announcement]').hidden = true;resize();});}
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
